import {Observable} from 'rxjs';
import {palipaliAPI} from '../provider/palipaliAPI';
import {ApiOperationResponseFunction} from '../base/apiConnectionInfrastructure';
import {RestQueryParams} from '../base/queryParams';
import {IApiSingleResponseBase} from '../../types';
import {IStripeOnboardingOutput, IStripeOnboardingInput} from '../../model/stripeOnboarding';

export const updateStripeOnboardingAPI: ApiOperationResponseFunction<IStripeOnboardingOutput> = (
    authToken: string,
    payload: {
        id: string;
        stripeOnboarding: IStripeOnboardingInput;
    }
): Observable<IApiSingleResponseBase<IStripeOnboardingOutput>> => {
    return palipaliAPI.put(`api/fleet_partners/${payload.id}/stripe_onboarding`, payload.stripeOnboarding, new RestQueryParams(), {
        Authorization: `Bearer ${authToken}`,
    });
};
